import axios from 'axios';
import { generateQueryString } from '@/helpers/QueryString.js';

const apiUrl = `${import.meta.env.VITE_APP_URL}/api`;

/**
 * @param {string} url
 * @param {AbortSignal} [signal]
 * @returns {Promise<any>}
 */
function get(url, signal) {
	return axios.get(url, signal ? { signal } : undefined).then((res) => res.data);
}

/**
 * @param {Record<string, string | number | boolean>} params
 * @param {AbortSignal} [signal]
 * @returns {Promise<import('@/types').CollegeOptionsData>}
 */
export function fetchCollegeOptions(params, signal) {
	return get(`${apiUrl}/options/college${generateQueryString(params)}`, signal).then((body) => body.data);
}

/**
 * @param {Record<string, string | number | boolean>} params
 * @param {AbortSignal} [signal]
 * @returns {Promise<import('@/types').TermOptionsData>}
 */
export function fetchTermOptions(params, signal) {
	return get(`${apiUrl}/options/term${generateQueryString(params)}`, signal).then((body) => body.data);
}

/**
 * @param {Record<string, string | number | boolean>} params
 * @param {AbortSignal} [signal]
 * @returns {Promise<import('@/types').CoursesData>}
 */
export function fetchCourses(params, signal) {
	return get(`${apiUrl}/courses${generateQueryString(params)}`, signal).then((body) => body.data);
}

/**
 * @param {Record<string, string | number | boolean>} params
 * @param {AbortSignal} [signal]
 * @returns {Promise<import('@/types').SearchBody>}
 */
export function fetchSearch(params, signal) {
	return get(`${apiUrl}/search${generateQueryString(params)}`, signal);
}

/**
 * @param {Record<string, string | number | boolean>} params
 * @param {AbortSignal} [signal]
 * @returns {Promise<import('@/types').SearchBody>}
 */
export function fetchSearchPage(params, signal) {
	return get(`${apiUrl}/search/page${generateQueryString(params)}`, signal);
}
